<script>
  import bulkJson from "../../../Publish/BulkUpload/Stores/jsonBulkData"
  import Loader from "../../../../Shared/Slots/loader.svelte"
  import { loadJs } from "../../../../Script/loadLibrary"
  import { capitalizeArrayEntries } from "../../../Publish/BulkUpload/Script/bulkUpload"
  import { flatenObject } from "../../../../Script/flatenObject"
  import { push } from "svelte-spa-router"
  import ConfirmationModal from "../../../Publish/BulkUpload/Shared/confirmationModal.svelte"
  import notify from "../../../../Script/notify"
  import { fetchBulkTemplate, generateXlFile } from "../../../Publish/BulkUpload/Script/bulkUpload"
  import { afterUpdate } from "svelte"
  import { loadTooltip } from "../../../../Script/loadTooltip"

  /**
   * @type {boolean} whether to show the loading screen or not
   */
  let showLoading = false

  export let json

  let showConfirmationModal = false

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })

  /**
   * Function to download an Excel sheet using exceljs library
   */
  const downloadSheet = async () => {
    try {
      showLoading = true
      let bulkData = await fetchBulkTemplate(json.id)

      $bulkJson = [...bulkData.documents]

      // Check if exceljs library is already loaded. If not, load it dynamically.
      await loadJs("ExcelJS", "assets/lib/exceljs.min.js")

      let header = capitalizeArrayEntries([...Object.keys(flatenObject(JSON.parse($bulkJson[0].metadata))), ...Object.keys(flatenObject(JSON.parse($bulkJson[0].options)))])

      console.log(header)
      // return
      if (bulkData.bulk.sendEmail) header.push("Email Sent")

      header = [...header, "Revokation Status", "Document URL"]

      let ValuesArr = []

      // Loop through each object in the $bulkJson array.
      for (let i = 0; i < $bulkJson.length; i++) {
        let values = []

        let options = JSON.parse($bulkJson[i].options)

        let metadata = JSON.parse($bulkJson[i].metadata)

        options.date = new Date(options.date).toDateString().slice(4)

        // let expireOn = "Nil"
        // if (options.expireOn) {
        //   expireOn = new Date(options.expireOn).toDateString().slice(4)
        //   delete options.expireOn
        // }

        // values = [...Object.values(flatenObject(metadata)), expireOn, ...Object.values(flatenObject(options))]

        let expireOn

        if (options.expireOn) {
          expireOn = new Date(options.expireOn).toDateString().slice(4)
          delete options.expireOn
        }

        values = [...Object.values(flatenObject(metadata)), ...(expireOn ? [expireOn] : []), ...Object.values(flatenObject(options))]

        if (bulkData.bulk.sendEmail) {
          values = [...values, $bulkJson[i].emailState ? "Successfully Sent" : "Not yet sent"]
        }
        values.push($bulkJson[i].notRevoked ? "Active" : "Revoked")

        values = [...values, $bulkJson[i].url]

        // Add the array of values for the current object to the ValuesArr.
        ValuesArr = [...ValuesArr, values]
      }

      // Call the generateXlFile function to create and download the Excel file
      await generateXlFile(header, ValuesArr, json.id)
    } catch (error) {
      const info = "PAGE: Bulk Session List\nEVENT: While Downloading Bulk Report"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }
</script>

{#if showConfirmationModal}
  <ConfirmationModal
    title="Revoke Bulk Document"
    content="Would you like to revoke all documents associated with the bulk template named <strong>{json.name}</strong>?"
    on:click={() => {
      showConfirmationModal = false
    }}
    on:confirm={() => {
      showConfirmationModal = false
      push(`/publish/bulk/revoke?id=${json.id}`)
    }}
  />
{/if}

<div class="relative mx-auto mt-3 flex h-full w-full flex-col gap-3 border-l-8 {json.status == 'active' || json.status == 'published' ? 'border-green-500 dark:hover:border-green-500' : json.status == 'revoked' ? 'border-red-500 dark:hover:border-red-500' : 'border-yellow-500 dark:hover:border-yellow-500'} rounded-r-md bg-white px-6 py-3 hover:shadow-md dark:border-y-2 dark:border-r-2 dark:border-y-transparent dark:border-r-transparent dark:bg-lightgray">
  {#if showLoading}
    <Loader>
      <span class="flex">
        {@html "Downloading Report&nbsp;&nbsp;"}
      </span>
    </Loader>
  {/if}
  <div class="flex w-full items-center justify-between gap-6">
    <div class="space-y-1.5 truncate">
      <div title={json.name} class="w-full truncate text-xs font-semibold text-gray-800 dark:text-gray-200 sm:text-base">{json.name}</div>
      <p class="font select-none truncate text-xs font-normal text-gray-200 sm:text-base">
        {#if json.status == "active" || json.status == "revoked"}
          <i class="fa-solid fa-calendar-days" />
          &nbsp;&nbsp;{new Date(json.created).toString().slice(0, 24)}
        {:else if json.status == "published"}
          <a href="#/publish/bulk/send-email?id={json.id}" class="active:blue-400 group flex items-center gap-3 text-gray-500 hover:text-blue-500 active:text-blue-400">
            <i class="fa-solid fa-envelope" />
            <span class="group-hover:underline">Emails not sent yet...</span>
          </a>
        {:else}
          <a href={json.status == "uploaded" ? `#/publish/bulk/sign-publish?id=${json.id}` : json.generateFile ? `#/publish/bulk/generate-file?id=${json.id}` : `#/publish/bulk/upload-file?id=${json.id}`} class="active:blue-400 group flex items-center gap-3 text-gray-500 hover:text-blue-500 active:text-blue-400">
            <i class="fa-solid fa-circle-play" />
            <span class="group-hover:underline">Resume the progress ...</span>
          </a>
        {/if}
      </p>
    </div>

    <div class="flex select-none justify-end">
      {#if json.status == "started" || json.status == "uploaded"}
        <a name="tooltip" id="Resume" tooltip-position="top" href={json.status == "uploaded" ? `#/publish/bulk/sign-publish?id=${json.id}` : json.generateFile ? `#/publish/bulk/generate-file?id=${json.id}` : `#/publish/bulk/upload-file?id=${json.id}`} type="button" class="flex items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white active:bg-sky-600 active:text-white disabled:cursor-not-allowed disabled:bg-none disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent sm:px-5">
          <i class="fa-solid fa-circle-play" />
          <span class="hidden lg:block">&nbsp;&nbsp;Resume&nbsp;</span>
        </a>
      {:else}
        <a name="tooltip" id="View Report" tooltip-position="top" href="#/documents/bulk/view-report?id={json.id}" type="button" class="flex items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white active:bg-sky-600 active:text-white disabled:cursor-not-allowed disabled:bg-none disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent sm:px-5">
          <i class="fa-solid fa-eye" />
          <span class="hidden lg:block">&nbsp;&nbsp;View&nbsp;Report&nbsp;</span>
        </a>
      {/if}
      <button name="tooltip" id="Download Report" tooltip-position="top" disabled={json.status == "started" || json.status == "uploaded"} on:click={downloadSheet} type="button" class="flex items-center justify-center rounded-full px-3 text-sm font-medium text-green-500 hover:bg-green-500 hover:text-white active:bg-green-600 active:text-white disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent sm:px-5">
        <i class="fa-solid fa-download" />
        <span class="hidden lg:block">&nbsp;&nbsp;Download&nbsp;Report&nbsp;</span>
      </button>
      <button
        name="tooltip"
        id={json.status == "revoked" ? "Revoked" : "Revoke"}
        tooltip-position="top"
        disabled={json.status == "started" || json.status == "uploaded" || json.status == "revoked"}
        on:click={() => {
          showConfirmationModal = true
        }}
        class="flex items-center justify-center gap-2 rounded-full px-3 text-sm font-medium text-red-500 hover:bg-red-500 hover:text-white active:bg-red-600 active:text-white disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent sm:px-5"
      >
        <i class="fa-solid fa-file-excel" />
        <span class="hidden lg:block">&nbsp;&nbsp;{json.status == "revoked" ? "Revoked" : "Revoke"}</span>
      </button>
    </div>
  </div>
</div>

<style>
  ::-webkit-scrollbar-thumb {
    background: #f7f7f7;
    border-radius: 20px;
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
</style>
